<template>
  <div class="article-wrapper">
    <div class="xile-logo">
      <img class="logo" src="@/assets/images/logo64.jpg" />
      <div class="txt">喜乐互联网医院</div>
    </div>
    <div class="data-loading" v-if="!dataDone">
      <van-loading type="spinner" size="14px">加载中...</van-loading>
    </div>
    <div class="article-header">{{articleEntry.title}}</div>
    <div class="article-center">
      <div class="article-user">
        <img class="user-avatar" :src="articleEntry.avatar" />
        <div class="user-name">
          {{articleEntry.author}}
        </div>
      </div>

    </div>
    <div class="article-labels">
      <div class="article-label" v-if="articleEntry.label!=null" :style="styles[index]" v-for="(label, index) in articleEntry.label"
        :key="index">{{label.name}}</div>
    </div>
    <div class="article-content" v-if="articleEntry!=null" v-for="(item, index) in articleEntry.content" :key="index">
      <div class="article-txt" v-if="item.row_type=='txt'">
        {{item.row_content}}
      </div>
      <img class="article-img" v-if="item.row_type=='img'" :src="item.row_content" />
      <video v-if="item.row_type=='video'" width="100%" class="article-video" :poster="cover_img" controls="">
        <source :src="item.row_content" type="video/mp4">
      </video>
    </div>
    <div class="article-other">
      阅读 {{articleEntry.hits}}
    </div>
    <div>
      <img class="xile-code" :src="articleEntry.qrcode">
      <!--
     <img class="xile-code" src="@/assets/images/qrcode_for_gh_ac86a49a4fd6_860.jpg">
     -->
      <div class="xile-code-tip">长按识别二维码</div>
    </div>

  </div>
</template>
<style lang="less" scoped>
  .article-wrapper {
    width: 100%;
    background-color: #fff;
    padding: 15px 0px;
    display: block;
    padding-top: 35px;

    .xile-code {
      width: 50%;
      margin: 5px auto;
      display: block;
    }

    .xile-code-tip {
      font-size: 13px;
      color: #676767;
      text-align: center;
      margin: 3px auto;
    }

    .xile-logo {
      height: 33px;
      width: 100%;
      background-color: #f5f5f5;
      border-bottom: solid 1px #EEEEEE;
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: row;
      justify-content: start;

      .logo {
        width: 30px;
        height: 30px;
        display: block;
        margin-left: 20px;
        margin-top: 2px;
      }

      .txt {
        color: #424242;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        font-weight: bold;
        margin-left: 10px;
        margin-top: 2px;
      }
    }

    .article-header {
      width: 92%;
      margin: 5px auto;
      padding: 3px 2%;
      font-size: 18px;
      font-weight: bold;
      line-height: 30px;
      color: #232323;
    }

    .article-center {
      margin: 2px auto;
      width: 90%;
      min-height: 50px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .article-user {
        min-width: 80px;
        height: 40px;
        margin-top: 3px;
        margin-left: 6px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
      }

      .user-avatar {
        width: 35px;
        height: 35px;

      }

      .user-name {
        color: #333333;
        font-size: 13px;
        height: 30px;
        line-height: 30px;
        margin-left: 5px;
      }

    }

    .article-labels {
      width: 90%;
      margin: 0px auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
    }

    .article-label {
      padding: 2px 13px;
      border-radius: 4px;
      font-size: 11px;
      height: 22px;
      line-height: 20px;
      text-align: center;
      margin: 5px 5px 0px 1px;
      display: block;
      color: #fff;
    }

    .article-content {
      width: 92%;
      margin: 3px auto;
      display: block;
      padding: 2px 0px;


      .article-txt {
        width: 96%;
        margin: 3px auto;
        font-size: 15px;
        color: #333333;
        text-indent: 2em;
        padding: 2px 0px;
        line-height: 30px;
      }

      .article-img {
        width: 100%;
        margin: 1px auto;
        display: block;
        border: solid 1px #f5f5f5;
        padding: 1px;

      }

      .article-video {
        width: 100%;
        margin: 1px auto;
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        max-height: 300px;

      }
    }

    .article-other {
      width: 90%;
      height: 20px;
      margin: 3px auto;
      font-size: 13px;
      color: #bebebe;
      padding: 0px 3px;
    }

  }
</style>

<script>
  export default {
    data() {
      return {
        article_id: this.$route.query.id, // this.$route.query.doc_id
        dataDone: false,
        styles: [
          'background-color:#6e8db0',
          'background-color:#6eb09d',
          'background-color:#b06e6e',
          'background-color:#aaaa7f',
          'background-color:#ff7d31',
          'background-color:#6e79b0',
          'background-color:#b06ea0'
        ],
        articleEntry: {},
        cover_img: 'http://v2.xilezaixian.com/view/index/template/src/assets/images/video-placehold.jpg'
      }
    },
    computed: {
      /*
      userInfo() {
        return this.$store.state.userInfo;
      }
      */
    },
    created() {
     location.href="http://v2.xilezaixian.com/article?id=" + this.article_id
      // 获取微信sdk签名
      let url = encodeURIComponent(window.location.href.split('#')[0])
      console.log(url)
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        console.log(data)
        if (data) {

          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
          });
        }
      });
      this.getArticle();
    },
    components: {},
    methods: {
      getArticle() {
        let _this = this;
        this.$root.post('/getArticle', {
          id: this.article_id,
        }).then(data => {
          this.dataDone = true;
          if (data.status) {

            document.title = data.info.title;
            if (data.info.cover_img != '') {
              this.cover_img = data.info.cover_img;
            }
            this.articleEntry = data.info;
            wx.onMenuShareAppMessage({
              "title": _this.articleEntry.title,
              "desc": '喜乐互联网医院',
              'link': 'http://v2.xilezaixian.com/article?id=' + _this.article_id,
              "imgUrl": _this.articleEntry.thumb,
              success: function(res) {
                 _this.updShare();
                console.log(res)
                // alert('分享成功')
              },
              cancel: function() {

              }
            });
            wx.onMenuShareTimeline({
              title: _this.articleEntry.title,
              link: 'http://v2.xilezaixian.com/article?id=' + _this.article_id,
              imgUrl: _this.articleEntry.thumb,
              success: function(res) {
                _this.updShare();
                console.log(res)
                // alert('分享成功')
              },
              cancel: function() {

              }
            });
          }
        })
      },
      updShare(){
        this.$root.post('/updArticleShare', {
          id: this.article_id,
        }).then(data => {

        });
      }



    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/articleDetail.vue